export const BANNER_VISIBILITY_KEY = 'banner_visible'
export const BANNER_VISIBILITY_VALUE = 'hidden'
